import * as Yup from "yup";

export const form = {
  formId: "new-carrier-form",
  formField: {
    carrierCode: {
      name: "carrierCode",
      label: "Carrier ID",
      type: "text",
      errorMsg: "Carrier ID is required.",
      required: true,
      //disabled:true,
      edit: true,
      maxLength: 20,
    },
    carrierName: {
      name: "carrierName",
      label: "Carrier Name",
      type: "text",
      errorMsg: "Carrier Name is required.",
      required: true,
      maxLength: 100,
    },
    transporterID: {
      name: "transporterID",
      label: "Transporter ID",
      type: "text",
      errorMsg: "Transporter ID is required.",
      required: true,
      maxLength: 20,
    },
  },
};

const formField = {
  carrierCode: {
    name: "carrierCode",
    label: "Carrier ID",
    type: "text",
    errorMsg: "Carrier ID is required.",
    required: true,
    editable: false,
    maxLength: 20,
  },
  carrierName: {
    name: "carrierName",
    label: "Carrier Name",
    type: "text",
    errorMsg: "Carrier Name is required.",
    required: true,
    maxLength: 100,
  },
  transporterID: {
    name: "transporterID",
    label: "Transporter ID",
    type: "text",
    errorMsg: "Transporter ID is required.",
    required: true,
    maxLength: 20,
  },
};

const { carrierCode, carrierName, transporterID } = formField;

export const formRender = [[carrierCode], [carrierName], [transporterID]];

export const initialValues = {
  [carrierCode.name]: null,
  [carrierName.name]: null,
  [transporterID.name]: null,
};

export const carrierValidations = Yup.object().shape({
  [carrierCode.name]: Yup.string().nullable().max(20).required(carrierCode.errorMsg),
  [carrierName.name]: Yup.string().nullable().max(100).required(carrierCode.errorMsg),
  [transporterID.name]: Yup.string().nullable().max(20).required(carrierCode.errorMsg),
});
